import { Route } from '@angular/router';
import { pagesRoutes } from './pages/pages.routes';

export const appRoutes: Route[] = [...pagesRoutes];
